import * as React from "react";
import {
	Form,
	FormGroup,
	ControlLabel,
	FormControl,
	HelpBlock,
	Schema,
	Button,
	ButtonToolbar,
} from "rsuite";
import styled from "styled-components";
import { Config, DesignSystem as DS, Endpoints } from "configs/index";
import { Notification } from "commons/Notification";
import Axios from "axios";

const { StringType } = Schema.Types;

const model = Schema.Model({
	password: StringType().isRequired("Este campo es requerido"),
	verifyPassword: StringType()
		.addRule((value, data) => {
			//console.log(data);

			if (value !== data.password) {
				return false;
			}

			return true;
		}, "Las contraseñas no coinciden")
		.isRequired("Este campo es requerido"),
});

const StyledButton = styled(Button).attrs((props) => ({
	fill: props.fill ? props.fill : DS.colors.primary,
	className: "mt-2",
}))`
	background: ${(props) => props.fill}!important;

	&:hover,
	&:active,
	&:focus,
	&:visited,
	&:focus-visible,
	&:active:focus {
		background: ${(props) => props.fill}!important;
	}
`;

interface IProps {
	user: { email: string; name: string };
	token: string | undefined;
	passwordChanged: any;
}

export default class ResetPassword extends React.Component<IProps, any> {
	_isMounted = false;
	constructor(props: any) {
		super(props);
		this.state = {
			token: "",
			user: { email: "", name: "" },
			formValue: {
				password: "",
				verifyPassword: "",
			},
		};
	}

	postRequest(
		pathRelative: string,
		data: any,
		success?: any,
		error?: any,
		always?: any
	) {
		const CancelToken = Axios.CancelToken;
		const source = CancelToken.source();

		Axios({
			method: "post",
			cancelToken: source.token,
			url: pathRelative,
			data: data,
			baseURL: Config.END_POINT,
		})
			.then(function (response) {
				if (success) {
					success(response);
				}
			})
			.catch(function (errors) {
				console.log("error", errors);
				if (error) {
					error(errors);
				}
			})
			.then(function () {
				if (always) {
					always();
				}
			});

		return source;
	}

	componentDidMount() {
		this._isMounted = true;
		const { token, user } = this.props;
		this._isMounted &&
			this.setState(
				{
					token: token,
					user: user,
				} /*, () =>
			console.log("reset state", this.state)*/
			);
	}

	componentWillUnmount() {
		this._isMounted = false;
		//console.log("unmounting");
	}

	handleSubmit() {
		const { formValue, token, user } = this.state;
		this.setState(
			(prevState: any) => ({
				spinner: true,
				formValue: { ...prevState.formValue },
			}),
			() => {
				//console.log(this.state);
				let data: any = {
					email: user.email,
					token: token,
					password: formValue.password,
					password_confirmation: formValue.verifyPassword,
				};
				this.setState(
					{
						spinner: true,
					} /* , () =>
					console.log("handleSubmit data", data, this.state) */
				);
				this.postRequest(
					Endpoints.POST_FORGOT_PASSWORD,
					data,
					this.success,
					this.error
				);
			}
		);
	}

	success = (response: any) => {
		const { passwordChanged } = this.props;
		//console.log("response:", response);
		//console.log(passwordChanged);
		this.setState({
			spinner: false,
			formValue: {
				password: "",
				verifyPassword: "",
			},
		});
		passwordChanged();
	};

	error = (error: any) => {
		Notification.errorObject(error);
	};

	static getDerivedStateFromProps(props: IProps, state: any) {
		//console.log("getDerivedStateFromProps", props, state);
		if (props.user !== state.user) {
			return {
				...state,
				user: props.user,
			};
		}
		return null;
	}

	render() {
		const { formValue, spinner, user } = this.state;
		return (
			<>
				<h5 className="d-flex align-items-center mt-4">
					<strong style={{ color: DS.colors.primary }}>
						Hola {user.name},
					</strong>
				</h5>
				<p className="mb-1">
					Aquí podrás ingresar una nueva contraseña de acceso
				</p>
				<Form
					model={model}
					fluid
					className="custom-form rs-form-group-m-b-10"
					onChange={(formValue) => {
						this.setState({ formValue });
					}}
					onSubmit={(check_status: boolean) =>
						check_status ? this.handleSubmit() : false
					}
					formValue={formValue}
				>
					<FormGroup className="required mt-4">
						<ControlLabel className="text-uppercase">
							Nueva Contraseña
						</ControlLabel>
						<FormControl name="password" type="password" />
						<HelpBlock className="d-none">Required</HelpBlock>
					</FormGroup>
					<FormGroup className="required mt-4">
						<ControlLabel className="text-uppercase">
							Repetir Contraseña
						</ControlLabel>
						<FormControl name="verifyPassword" type="password" />
						<HelpBlock className="d-none">Required</HelpBlock>
					</FormGroup>
					<div className="d-flex justify-content-between align-items-center">
						<a href={Config.BASE_URL}>Volver al login</a>
						<ButtonToolbar className="d-flex justify-content-end">
							<StyledButton
								appearance="primary"
								type="submit"
								loading={spinner}
							>
								Modificar contraseña
							</StyledButton>
						</ButtonToolbar>
					</div>
				</Form>
			</>
		);
	}
}
